import React from 'react';
import moment from 'moment';
import '../css/dataTables.css';
import { CURRENCY, FORMAT_NUMBER } from '../libs/utils/Const';
 
const renderTableBody = (headers, data, action, checkbox) => {
    let body = "";
    body = data.map((vendor, index) => {
        return (
            <tr key={index}>
                <td style={{ textAlign: "center", width: 100 }}>
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)}
                        onChange={() => checkbox.selectOne(index)} />
                </td>
                <td>{vendor.CardCode || ""}</td>
                <td>{vendor.CardName || ""}</td>
                
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, checkbox) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">
                #
            </td>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, checkbox);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%' }}>
                <thead className="table-header">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableVendorsModal = (headers, data, action, checkbox) => {

    return renderTable(headers, data, action, checkbox);

}
